export const abbrMap: Record<string, string> = {
  вулиця: 'street',
  проспект: 'avenue',
  станція: 'station',
  площа: 'square',
  місто: 'city',
  'селище міського типу': 'urban-type settlement',
  село: 'village'
};
